/**
 * ref
 *
 * helper for React refs
 *
 * @param {string} name property name to assign the element reference
 */
function ref(obj, name = 'el') {
    return (el) => {
        obj[name] = el
    }
}

module.exports = ref
